import React, { useEffect, useState } from "react";
import { Form, Table, Tabs, Tab } from "react-bootstrap";
import { Ellipsis } from "react-awesome-spinners";

import { getTxHistory, getRewardHistory, getClaimHistory } from "../ApiAction/api"; // Add reward API
import { dateFormat, shortText, formatNumber } from "../helper/custommath";
import config from "../config/config";



export default function BuyHistory(props) {
    const [tabKey, setTabKey] = useState("purchase");

    const [dataList, setDataList] = useState([]);
    const [loader, setLoader] = useState(false);
    const [loadHistory, setLoadHistory] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const recordsPerPage = 10;

    useEffect(() => {
        fetchData(tabKey, currentPage);
    }, [tabKey, currentPage, loadHistory]);

    useEffect(() => {
        setLoadHistory(props.loadhistory);
    }, [props.loadhistory]);

    const fetchData = async (type, page) => {
        setLoader(true);
        const apiFn = type === "reward" ? getClaimHistory : getTxHistory;

        const { result = [], totalRecords = 0 } = await apiFn({
            limit: recordsPerPage, skip: page
        });

        setDataList(result);
        setTotalRecords(totalRecords);
        setTimeout(() => setLoader(false), 500);
        props.setloadhistory(false);
    };

    const totalPages = Math.ceil(totalRecords / recordsPerPage);

    return (
        <>
            <Form.Label className="input_join mt-4" htmlFor="inputPassword5">
                History
            </Form.Label>

            <Tabs activeKey={tabKey} onSelect={(k) => {
                setTabKey(k);
                setCurrentPage(1);
            }} className="mb-3 history_tab">
                <Tab eventKey="purchase" title="Purchase History" />
                <Tab eventKey="reward" title="Claim History" />
            </Tabs>

            <Table responsive className="referral_table">
                <thead>
                    <tr>
                        <th>Date & Time</th>
                        <th>Wallet</th>
                        {/* {tabKey == "reward" && <th>BucketId</th>} */}
                        {tabKey == "reward" && <th>BidAmount</th>}
                        {tabKey == "reward" && <th>Withdraw Amt</th>}
                        {tabKey == "reward" && <th>Equivalent Amt</th>}
                        {/* {tabKey == "reward" && <th>Position Value</th>} */}
                        {tabKey == "purchase" && <th>Paid</th>}
                        {tabKey == "purchase" && <th>Receive</th>}
                        {tabKey == "purchase" && <th>RefferalUser</th>}
                        {tabKey == "purchase" && <th>Refferal Amount(10%USDT)</th>}
                        <th>TxHash</th>
                    </tr>
                </thead>
                <tbody>
                    {dataList.length > 0 &&
                        dataList.map((item, i) => (
                            <tr key={i}>
                                <td>{dateFormat(item.createdAt, "DD-MM-YYYY hh::mm")}</td>
                                <td>
                                    <a
                                        href={`${config.txurl}/address/${item.address}`}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {shortText(item.address)}
                                    </a>
                                </td>
                                {tabKey == "purchase" && <td>{formatNumber(item.pay || 0, 6)} USDT</td> }
                                {tabKey == "purchase" ? <td>{formatNumber(item.receive || 0, 6)} WIN</td> : <td>{formatNumber(item.bidAmt || 0, 6)} WIN</td>}
                                {tabKey == "reward" && <td>{formatNumber(item.withdrawAmt || 0, 6)} WIN</td>}
                                {tabKey == "reward" && <td>{formatNumber(item.EquiAmt || 0, 6)} USDT</td>}
                                {/* {tabKey == "reward" && <td>{formatNumber(item.bucketPosValue || 0, 6)} USDT</td>} */}
                                {tabKey == "purchase" && <td>
                                    <a
                                        href={`${config.txurl}/address/${item.referralUser}`}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {shortText(item.referralUser)}
                                    </a>
                                </td>
                                }
                                {tabKey == "purchase" && 
                                <td>{formatNumber(item.refBonusAmt || 0, 6)} USDT</td> }
                                <td>
                                    <a
                                        href={`${config.txurl}/tx/${item.txId}`}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        {shortText(item.txId)}
                                    </a>
                                </td>
                            </tr>
                        ))}

                    {!loader && dataList.length === 0 && (
                        <tr>
                            <td colSpan="5">No records</td>
                        </tr>
                    )}
                </tbody>
            </Table>

            {loader && (
                <div className="text-center">
                    <Ellipsis className="loading mx-auto" color="white" />
                </div>
            )}

            {totalRecords > 0 && (
                <div className="pagination-buttons text-center mt-3">
                    <button
                        className={
                            currentPage === 1
                                ? "primary_btn me-2"
                                : "primary_btn me-2 diabledbtn"
                        }
                        onClick={() => setCurrentPage(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        Previous
                    </button>
                    <span>
                        Page {currentPage} of {totalPages}
                    </span>
                    <button
                        className={
                            currentPage === totalPages
                                ? "primary_btn me-2"
                                : "primary_btn me-2 diabledbtn"
                        }
                        onClick={() => setCurrentPage(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        Next
                    </button>
                </div>
            )}
        </>
    );
}
